const ROOT = 'TALENTS_BULK_UPLOAD_WORKERS_MODAL_';

const actions = {
  CHANGE_MODAL_VISIBILITY: `${ROOT}CHANGE_MODAL_VISIBILITY`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  ADD_NEW_SKILL: `${ROOT}ADD_NEW_SKILL`,
  CHANGE_POSITION: `${ROOT}CHANGE_POSITION`,
  CHANGE_TIER: `${ROOT}CHANGE_TIER`,
  REMOVE_SKILL: `${ROOT}REMOVE_SKILL`,
  BULK_UPLOAD_WORKERS_REQUEST: `${ROOT}BULK_UPLOAD_WORKERS_REQUEST`,
  BULK_UPLOAD_WORKERS_SUCCESS: `${ROOT}BULK_UPLOAD_WORKERS_SUCCESS`,
  BULK_UPLOAD_WORKERS_ERROR: `${ROOT}BULK_UPLOAD_WORKERS_ERROR`,
  CLEAR_STATE: `${ROOT}CLEAR_STATE`,
} as const;

export default actions;
